var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6875 6.47917L19.6562 8.51042L15.4896 4.34375L17.5208 2.3125C17.7292 2.10417 17.9896 2 18.3021 2C18.6146 2 18.875 2.10417 19.0833 2.3125L21.6875 4.91667C21.8958 5.125 22 5.38542 22 5.69792C22 6.01042 21.8958 6.27083 21.6875 6.47917ZM2 17.8333L14.2917 5.54167L18.4583 9.70833L6.16667 22H2V17.8333Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-edit.e2cd732fe299fbcbb738d4d9a2bec3b9.svg";